import { combineReducers } from 'redux';

import filesReducer from './filesReducer';

const rootReducer = combineReducers({
    filesState: filesReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./frontEnd/covid/permiso-unico-colectivo/reducers/index.js